import App from '../../containers/ProductArea'
import { useDebug } from '../../hooks';

import {
  buggyData,
  simpleData,
  variableData,
  bundleData,
  demoData,
  Container,
  Content, 
  GlobalStyles, 
  StyleSheets,
  Header, 
  HeaderRow, 
  DemoContent,
  DemoLogo,
} from '../demo-utils'

const handleAddToCart = (({id, type, selected, quantity: {selected: quantity}}: any) => {
  console.log('handleAddToCart', {id, type, selected, quantity});
})

const AppDemo = () => {
  useDebug(`AppDemo`)
  
  return (<> 
    <StyleSheets url={demoData.config.stylesheetURL} />
    <GlobalStyles fontFamily={demoData.config.fontFamily} />
    <Container>
      {/* <App {...simpleData} onAddToCart={handleAddToCart} /> */}
      <App {...buggyData} onAddToCart={handleAddToCart} />
      {/* <App {...variableData} onAddToCart={handleAddToCart} /> */}
      {/* <App {...bundleData} onAddToCart={handleAddToCart}/> */}
    </Container>
  </>)
}

export default AppDemo
